<template>
  <div style="color: #98c179" class="la-ball-spin-clockwise-fade" :class="[size, classes]">
    <img src="img/icons/icon-flower-darker-green.png" />
    <img src="img/icons/icon-flower-darker-green.png" />
    <img src="img/icons/icon-flower-darker-green.png" />
    <img src="img/icons/icon-flower-darker-green.png" />
    <img src="img/icons/icon-flower-darker-green.png" />
    <img src="img/icons/icon-flower-darker-green.png" />
    <img src="img/icons/icon-flower-darker-green.png" />
    <img src="img/icons/icon-flower-darker-green.png" />
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    size: { type: String, default: "la-2x" },
    classes: { type: String, default: "mx-auto mt-4 mb-4" },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style scoped>
/*!
 * Load Awesome v1.1.0 (http://github.danielcardoso.net/load-awesome/)
 * Copyright 2015 Daniel Cardoso <@DanielCardoso>
 * Licensed under MIT
 */
.la-ball-spin-clockwise-fade,
.la-ball-spin-clockwise-fade > img {
  position: relative;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.la-ball-spin-clockwise-fade {
  display: block;
  font-size: 0;
  color: #fff;
}
.la-ball-spin-clockwise-fade.la-dark {
  color: #333;
}
.la-ball-spin-clockwise-fade > img {
  display: inline-block;
  float: none;
  /* background-color: currentColor; */
  /* border: 0 solid currentColor; */
}
.la-ball-spin-clockwise-fade {
  width: 32px;
  height: 32px;
}
.la-ball-spin-clockwise-fade > img {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  margin-top: -4px;
  margin-left: -4px;
  border-radius: 100%;
  -webkit-animation: ball-spin-clockwise-fade 1s infinite linear;
  -moz-animation: ball-spin-clockwise-fade 1s infinite linear;
  -o-animation: ball-spin-clockwise-fade 1s infinite linear;
  animation: ball-spin-clockwise-fade 1s infinite linear;
}
.la-ball-spin-clockwise-fade > img:nth-child(1) {
  top: 5%;
  left: 50%;
  -webkit-animation-delay: -0.875s;
  -moz-animation-delay: -0.875s;
  -o-animation-delay: -0.875s;
  animation-delay: -0.875s;
}
.la-ball-spin-clockwise-fade > img:nth-child(2) {
  top: 18.1801948466%;
  left: 81.8198051534%;
  -webkit-animation-delay: -0.75s;
  -moz-animation-delay: -0.75s;
  -o-animation-delay: -0.75s;
  animation-delay: -0.75s;
}
.la-ball-spin-clockwise-fade > img:nth-child(3) {
  top: 50%;
  left: 95%;
  -webkit-animation-delay: -0.625s;
  -moz-animation-delay: -0.625s;
  -o-animation-delay: -0.625s;
  animation-delay: -0.625s;
}
.la-ball-spin-clockwise-fade > img:nth-child(4) {
  top: 81.8198051534%;
  left: 81.8198051534%;
  -webkit-animation-delay: -0.5s;
  -moz-animation-delay: -0.5s;
  -o-animation-delay: -0.5s;
  animation-delay: -0.5s;
}
.la-ball-spin-clockwise-fade > img:nth-child(5) {
  top: 94.9999999966%;
  left: 50.0000000005%;
  -webkit-animation-delay: -0.375s;
  -moz-animation-delay: -0.375s;
  -o-animation-delay: -0.375s;
  animation-delay: -0.375s;
}
.la-ball-spin-clockwise-fade > img:nth-child(6) {
  top: 81.8198046966%;
  left: 18.1801949248%;
  -webkit-animation-delay: -0.25s;
  -moz-animation-delay: -0.25s;
  -o-animation-delay: -0.25s;
  animation-delay: -0.25s;
}
.la-ball-spin-clockwise-fade > img:nth-child(7) {
  top: 49.9999750815%;
  left: 5.0000051215%;
  -webkit-animation-delay: -0.125s;
  -moz-animation-delay: -0.125s;
  -o-animation-delay: -0.125s;
  animation-delay: -0.125s;
}
.la-ball-spin-clockwise-fade > img:nth-child(8) {
  top: 18.179464974%;
  left: 18.1803700518%;
  -webkit-animation-delay: 0s;
  -moz-animation-delay: 0s;
  -o-animation-delay: 0s;
  animation-delay: 0s;
}
.la-ball-spin-clockwise-fade.la-sm {
  width: 16px;
  height: 16px;
}
.la-ball-spin-clockwise-fade.la-sm > img {
  width: 4px;
  height: 4px;
  margin-top: -2px;
  margin-left: -2px;
}
.la-ball-spin-clockwise-fade.la-2x {
  width: 64px;
  height: 64px;
}
.la-ball-spin-clockwise-fade.la-2x > img {
  width: 16px;
  height: 16px;
  margin-top: -8px;
  margin-left: -8px;
}
.la-ball-spin-clockwise-fade.la-3x {
  width: 96px;
  height: 96px;
}
.la-ball-spin-clockwise-fade.la-3x > img {
  width: 24px;
  height: 24px;
  margin-top: -12px;
  margin-left: -12px;
}
/*
 * Animation
 */
@-webkit-keyframes ball-spin-clockwise-fade {
  50% {
    opacity: 0.25;
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
  }
  100% {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@-moz-keyframes ball-spin-clockwise-fade {
  50% {
    opacity: 0.25;
    -moz-transform: scale(0.5);
    transform: scale(0.5);
  }
  100% {
    opacity: 1;
    -moz-transform: scale(1);
    transform: scale(1);
  }
}
@-o-keyframes ball-spin-clockwise-fade {
  50% {
    opacity: 0.25;
    -o-transform: scale(0.5);
    transform: scale(0.5);
  }
  100% {
    opacity: 1;
    -o-transform: scale(1);
    transform: scale(1);
  }
}
@keyframes ball-spin-clockwise-fade {
  50% {
    opacity: 0.25;
    -webkit-transform: scale(0.5);
    -moz-transform: scale(0.5);
    -o-transform: scale(0.5);
    transform: scale(0.5);
  }
  100% {
    opacity: 1;
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }
}
</style>
